module.exports = __webpack_public_path__ + "img/SGW_Free_sword.a52b2a01.png";